import { useMemo, useState } from 'react';
import { useTranslation } from 'react-i18next';
import { Button, Divider, Text } from 'ui';
import { useUser } from '../../auth';
import { useGetTranslateMutation } from '../queries';

type P = {
  id: string;
  type: string;
};

const Translation = ({ id, type }: P) => {
  const [translatedText, setTranslatedText] = useState('');
  const { i18n } = useTranslation();
  const { isPending: isLoading, mutateAsync: getTranslate } = useGetTranslateMutation();
  const user = useUser({ requiredAuth: false });

  const language = useMemo(() => {
    if (
      user &&
      user.railsUserData.settings.translations.enableTranslations.value &&
      'language' in user.railsUserData.settings.translations
    ) {
      return user.railsUserData.settings.translations.language.value;
    }

    return i18n.language;
  }, [i18n.language, user]);

  if (!user?.railsUserData.settings.translations.enableTranslations.value) {
    return null;
  }

  return (
    <div className="translation">
      {translatedText ? (
        <>
          <Divider className="translation--divider" />
          <Text type="secondary">{translatedText}</Text>
          <br />
          <Button
            onClick={() => {
              setTranslatedText('');
            }}
            type="link-primary"
          >
            Hide Translation
          </Button>
        </>
      ) : (
        <Button
          loading={isLoading}
          onClick={async () => {
            const translation = await getTranslate({ id, language, type });
            setTranslatedText(translation.translatedTextContent);
          }}
          type="link-primary"
        >
          See Translation
        </Button>
      )}
    </div>
  );
};

export default Translation;
